import { ReactNode } from 'react';
import styled, { css } from 'styled-components';

interface TdProps {
  borderRight?: boolean;
  isRowSelected?: boolean;
  isDragging?: boolean;
  children?: ReactNode;
}

export const Td = styled.div<TdProps>`
  display: inline-block;
  padding: 21px 15px;
  vertical-align: top;
  font:
    400 16px/1.2em 'Open Sans',
    sans-serif;
  position: relative;
  white-space: unset;
  word-break: break-word;

  ${({ borderRight }) =>
    borderRight &&
    css`
      border-right: 1px solid #aaa;

      :last-child {
        border-right: none;
      }
    `}

  ${({ isRowSelected, theme }) =>
    isRowSelected &&
    css`
      color: ${theme.palette.text.secondary};
    `}

  ${({ isDragging, theme }) =>
    isDragging &&
    css`
      margin: 0 -25px;
      min-height: 120px;
      width: 100vw;

      background-color: ${theme.colors.tableSelection};
      border-color: ${theme.colors.tableSelection};
      color: ${theme.palette.text.secondary};
    `}
`;
